const AppCommHandler = {
    store:null,
    setStore(store){
        this.store = store;
    },
    handleAPIError(error){
        //This might generate an Error which will be consumed by someone....
        if (!error.consumed) {
            this.store.dispatch({
                    type: 'API_EXECUTION_REJECTED',
                    payload:error
            });
        }
    },
    APIStartEvent(){
        
        this.store.dispatch({
                type: 'API_EXECUTION_START',
                payload:"API_CALL_START"
        });
    },
    APIEndEvent(){
        this.store.dispatch({
                type: 'API_EXECUTION_END',
                payload:"API_CALL_END"
        });
    },
    APISessionExpiredEvent(){
        this.store.dispatch({
                type: 'API_SESSION_EXPIRED',
                payload:"API_SESSION_EXPIRED"
        });
    },
    APIBreadcrumbEvent(breadcrumb){
        this.store.dispatch({
                type: 'VIEW_CHANGED',
                payload:breadcrumb
        });
    },
    handleOutsideASTNetworkLinkObserved(){
        this.store.dispatch({
                type: 'OUTSIDE_LINK_FOUND',
                payload:"OUTSIDE_LINK_FOUND"
        });
    },
    handleAppLoadError(){
        this.store.dispatch({
                type: 'APP_LOAD_ERROR',
                payload:"APP_LOAD_ERROR"
        });
    }
};
export default AppCommHandler;